import { useState, useEffect, useCallback } from "react";
import { useSocket } from "../context/SocketContext";
import { Socket } from "socket.io-client";

interface KarmaState {
  isActive: boolean;
  participants: string[];
  winners: string[];
  prize: number;
  showBombOverlay: boolean;
}

export function useKarma() {
  const { socket } = useSocket() as {
    socket: Socket | null;
    isConnected: boolean;
  };
  const [karmaState, setKarmaState] = useState<KarmaState>({
    isActive: false,
    participants: [],
    winners: [],
    prize: 0,
    showBombOverlay: false,
  });

  const resetKarma = useCallback(() => {
    setKarmaState({
      isActive: false,
      participants: [],
      winners: [],
      prize: 0,
      showBombOverlay: false,
    });
  }, []);

  useEffect(() => {
    if (!socket) return;

    const handleOverlay = (data: any) => {
      switch (data.type) {
        case "karma:start":
          setKarmaState({
            isActive: true,
            participants: [],
            winners: [],
            prize: 0,
            showBombOverlay: false,
          });
          break;

        case "karma:join":
          if (data.data?.username) {
            setKarmaState((prev) => ({
              ...prev,
              participants: [...prev.participants, data.data.username],
            }));
          }
          break;

        case "karma:winners":
          if (data.data?.winners && Array.isArray(data.data.winners)) {
            setKarmaState((prev) => ({
              ...prev,
              winners: data.data.winners,
              prize: data.data.prize || 0,
              showBombOverlay: true,
            }));
          }
          break;

        default:
          break;
      }
    };

    socket.on("overlay", handleOverlay);

    return () => {
      socket.off("overlay", handleOverlay);
    };
  }, [socket]);

  return {
    ...karmaState,
    resetKarma,
  };
}
